import type { ICommunity } from '~/entities/container/community/interfaces/community'
import type { IUser } from '~/entities/user/user/interfaces/user'

import type { INetworkActivity } from '~/features-swym/network-activity/interfaces/network-activity'
import { Action, Type } from '~/features-swym/network-activity/interfaces/network-activity'

import { dateParser } from '~/features-shared/content/api/parser-contents'
import { IContentModel } from '~/features-shared/content/interfaces/content-model'
import type { ISwymContent } from '~/features-shared/content/interfaces/swym-content'
import { logger } from '~/features-shared/libs/utils/logger'

function typeParser(content: ISwymContent): Type {
  switch (content.model) {
    case IContentModel.Post:
      return Type.Post
    case IContentModel.Idea:
      return Type.Idea
    case IContentModel.Media:
      return Type.Media
    case IContentModel.Question:
      return Type.Question
    case IContentModel.Rituals:
      return Type.Rituals
    case IContentModel.Survey:
      return Type.Survey
    case IContentModel.Wedo:
      return Type.Wedo
    case IContentModel.Wiki:
      return Type.WikiPage
    case IContentModel.Conference:
      return Type.Meeting
    default:
      return logger.log('type not found')
  }
}
export function _networkActivityParser(content: ISwymContent): INetworkActivity {
  return {
    subject_uri: content.subject6wuri || '',
    created_at: '',
    action: Action.Create,
    community: { id: content.community_id, title: content.community_title } as ICommunity,
    content_uri_list: [],
    date: dateParser(content.publish_date) as string,
    derived_type: content.derived_type,
    subtype: null,
    target_id: content.model_id,
    target_label: content.title || '',
    model: content.model,
    type: typeParser(content),
    user: content.author as IUser,
    title: content.title || '',
  }
}

export function networkActivityParser(responseContent: ISwymContent): INetworkActivity {
  return _networkActivityParser(responseContent)
}
